module.exports = __webpack_public_path__ + "static/media/stop-watch-ticks-only.303cea40.svg";